import { AfterViewInit, Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment';

export interface SurveyOptInRenderDataProduct {
    gtin: string;
}
export interface SurveyOptInRenderData {
    merchant_id: number;
    order_id: string;
    email: string;
    delivery_country: string;
    estimated_delivery_date: string;
    products: Array<SurveyOptInRenderDataProduct>;
    opt_in_style: string; // default "CENTER_DIALOG"
}

@Component({
    selector: 'google-customer-reviews',
    templateUrl: './google-customer-reviews.component.html'
})
export class GoogleCustomerReviewsComponent implements AfterViewInit {
    @Input('offer') offer;

    public merchantId = null;
    public optInStyle = 'CENTER_DIALOG';
    public data: any|SurveyOptInRenderData;

    constructor(
        protected activatedRoute: ActivatedRoute
    ) {
        this.activatedRoute.data.map((data) => {
            return data.storeConfigurations;
        }).subscribe(data => {
            this.catchProperties(data);
        });
    }

    ngAfterViewInit() {
        if (null !== this.merchantId) {
            this.data = this.buildRenderData();
        }
    }

    private catchProperties(data) {
        if (
            data['google-customer-reviews-merchant-id'] !== undefined
            && data['google-customer-reviews-merchant-id'] !== null
        ) {
            this.merchantId = data['google-customer-reviews-merchant-id'];
        }

        if (
            data['google-customer-reviews-opt-in-style'] !== undefined
            && data['google-customer-reviews-opt-in-style'] !== null
        ) {
            this.optInStyle = data['google-customer-reviews-opt-in-style'];
        }
    }
    private buildRenderData() {
        let estimatedDeliveryDate = this.offer.deliveries.zip_code_range.deadline;
        if (null !== this.offer.deliveries.zip_code_range.deadline_limit) {
            estimatedDeliveryDate = this.offer.deliveries.zip_code_range.deadline_limit;
        }
        const estimatedDeliveryDate$ = moment(estimatedDeliveryDate);
        const data = {
            merchant_id: this.merchantId,
            order_id: `${this.offer.id}`,
            email: this.offer.client.email,
            delivery_country: 'BR',
            estimated_delivery_date: estimatedDeliveryDate$.format('YYYY-MM-DD'),
            opt_in_style: this.optInStyle
        };
        const products = this.buildProducts();

        if (products.length > 0) {
            data['products'] = products;
        }

        return data;
    }
    private buildProducts(): Array<SurveyOptInRenderDataProduct> {
        const items = [];
        if (this.offer.plan !== undefined) {
            items.push({gtin: this.offer.plan.id});
        }
        if (this.offer.items !== undefined) {
            for (let item of this.offer.items) {
                items.push({gtin: item.item.ean});
            }
        }

        return items.filter(item => null !== item.gtin);
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src3894461559/src/src/app/shared/components/google-customer-reviews/google-customer-reviews.component.ts